/**
 * Created by: Kiran G
 * Updated by: Akanksha J
 * Component: Local storage service
 * Updated date: 20/12/2019
 */
import * as tslib_1 from "tslib";
import { Injectable } from '@angular/core';
let LocalStorageService = class LocalStorageService {
    /**
     * angular method for declaring packages in variables
     *
     * which runs first in this particulat component
     */
    constructor() {
        this.userId = 'userId';
        this.userToken = 'userToken';
        this.selectedLanguage = 'selectedLanguage';
        this.editorContentEnglish = 'editorContentEnglish';
        this.editorContentMarathi = 'editorContentMarathi';
        this.isBlind = 'false';
    }
    setToken(token) {
        localStorage.setItem(this.userToken, token);
    }
    getToken() {
        return localStorage.getItem(this.userToken);
    }
    setUserId(userId) {
        localStorage.setItem(this.userId, userId);
    }
    setToBlind(isBlind) {
        localStorage.setItem(this.isBlind, isBlind);
    }
    getIsBlind() {
        return localStorage.getItem(this.isBlind);
    }
    getUserId() {
        return localStorage.getItem(this.userId);
    }
    getContentEnglishMarathi(type) {
        if (type == 'en')
            return localStorage.getItem(this.editorContentEnglish);
        else if (type == 'mar')
            return localStorage.getItem(this.editorContentMarathi);
    }
    setContentEnglishMarathi(type, content) {
        if (type == 'en')
            localStorage.setItem(this.editorContentEnglish, content);
        else if (type == 'mar')
            localStorage.setItem(this.editorContentMarathi, content);
    }
    clearLocalStorage() {
        localStorage.clear();
    }
    getItem(item) {
        return localStorage.getItem(item);
    }
    setItem(item, value) {
        localStorage.setItem(item, value);
    }
};
LocalStorageService = tslib_1.__decorate([
    Injectable({
        providedIn: 'root'
    }),
    tslib_1.__metadata("design:paramtypes", [])
], LocalStorageService);
export { LocalStorageService };
//# sourceMappingURL=localstorage.service.js.map